import {
  makeColorSchema,
  rainbowRandomColors
} from "./chunk-SNUDSNGS.js";
import "./chunk-EUXUH3YW.js";

// libs/core/src/lib/theme/themes/brand-color-schemes/rainbow.style.ts
var rainbowStyle = makeColorSchema(rainbowRandomColors[0]);
export {
  rainbowStyle
};
//# sourceMappingURL=rainbow.style-POOUJKCE.js.map
